import { render, staticRenderFns } from "./payError.vue?vue&type=template&id=7cdcd430"
import script from "./payError.vue?vue&type=script&lang=js"
export * from "./payError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports